import { createFileRoute } from '@tanstack/react-router';
import { P } from '@vagusx/shared';
import CampaignPage from '@/pages/campaigns/CampaignPage';
import { campaignPageSearch } from '@/pages/campaigns/campaign-tabs';
import { requireRoutePermission } from '@/lib/route-guard';

export const Route = createFileRoute('/_authenticated/campaigns/$id/')({
  beforeLoad: () => requireRoutePermission(P.OUTREACH_VIEW),
  validateSearch: campaignPageSearch,
  component: CampaignPage,
});
